// 토큰 관리 유틸리티
export const TOKEN_KEYS = {
  ACCESS_TOKEN: "accessToken",
  REFRESH_TOKEN: "refreshToken",
  // OAuth 토큰 키들
  KAKAO_ACCESS_TOKEN: "kakao_access_token",
  GOOGLE_ACCESS_TOKEN: "google_access_token",
  NAVER_ACCESS_TOKEN: "naver_access_token",
  APPLE_ACCESS_TOKEN: "apple_access_token",
} as const;

// 토큰 저장
export const setTokens = (accessToken: string, refreshToken: string) => {
  console.log("Storing new tokens", {
    accessToken: accessToken.substring(0, 10) + "...",
    refreshToken: refreshToken.substring(0, 10) + "...",
  });

  localStorage.setItem(TOKEN_KEYS.ACCESS_TOKEN, accessToken);
  localStorage.setItem(TOKEN_KEYS.REFRESH_TOKEN, refreshToken);
};

// 액세스 토큰 가져오기
export const getAccessToken = (): string | null => {
  const token = localStorage.getItem(TOKEN_KEYS.ACCESS_TOKEN);
  return token;
};

// 리프레시 토큰 가져오기
export const getRefreshToken = (): string | null => {
  const token = localStorage.getItem(TOKEN_KEYS.REFRESH_TOKEN);
  return token;
};

// OAuth 토큰 저장
export const setOAuthToken = (provider: string, accessToken: string) => {
  const key = `${provider}_access_token`;
  localStorage.setItem(key, accessToken);
  console.log(`Storing ${provider} OAuth token`);
};

// OAuth 토큰 가져오기
export const getOAuthToken = (provider: string): string | null => {
  const key = `${provider}_access_token`;
  return localStorage.getItem(key);
};

// OAuth 토큰 삭제
export const clearOAuthToken = (provider: string) => {
  const key = `${provider}_access_token`;
  localStorage.removeItem(key);
  console.log(`Clearing ${provider} OAuth token`);
};

// 모든 OAuth 토큰 삭제
export const clearAllOAuthTokens = () => {
  Object.values(TOKEN_KEYS).forEach((key) => {
    if (key.includes("_access_token")) {
      localStorage.removeItem(key);
    }
  });
  console.log("Clearing all OAuth tokens");
};

// 토큰 삭제 (로그아웃) - OAuth 토큰도 함께 삭제
export const clearTokens = () => {
  console.log("Clearing all tokens");
  localStorage.removeItem(TOKEN_KEYS.ACCESS_TOKEN);
  localStorage.removeItem(TOKEN_KEYS.REFRESH_TOKEN);
  clearAllOAuthTokens();

  // SNS 타입 정보도 삭제
  sessionStorage.removeItem("local-sign-sns-type");
  localStorage.removeItem("local-sign-sns-type");
  localStorage.removeItem("local-sns-id");
};

// 토큰 존재 여부 확인
export const hasTokens = (): boolean => {
  const hasAccess = !!getAccessToken();
  const hasRefresh = !!getRefreshToken();
  console.log("Token status check:", {
    hasAccessToken: hasAccess,
    hasRefreshToken: hasRefresh,
  });
  return hasAccess && hasRefresh;
};
